import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=10ce2540&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=10ce2540&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=10ce2540&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce2540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10ce2540')) {
      api.createRecord('10ce2540', component.options)
    } else {
      api.reload('10ce2540', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=10ce2540&scoped=true", function () {
      api.rerender('10ce2540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platList/detail.vue"
export default component.exports